export const quotaExceededErrors = [
  'keys and/or value are too large', // WebKit
  'value is too large', // Firefox
  'QuotaExceededError', // Various, possibly a cache error
]
